import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorgeService {
ttl: number = 1 //in houers
constructor() { }

  getFromStorge(key: string) {
    const itemStr = sessionStorage.getItem(key)
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    if (now.getTime() > item.expiry) {
      sessionStorage.removeItem(key)
      return null
    }
    return item.value
  }

  setInStorge(ket:string,value: any, ttl?: any) {
    const storgeItem = {value: value, expiry: new Date().getTime() + ((ttl ? ttl: this.ttl) * 3600000)}
    sessionStorage.setItem(ket, JSON.stringify(storgeItem))
  }

  claerStorge() {
    sessionStorage.clear()
  }
}
